import classes from './index.module.scss'
import { UserMenu } from './UserMenu'

interface Props {
  leftElement?: React.ReactNode
}

export const UserMenuTopBar = ({ leftElement }: Props) => (
  <div className={classes.root}>
    <div className={classes.leftElementWrapper}>{leftElement}</div>
    <div className={classes.rightElementWrapper}>
      <UserMenu />
    </div>
  </div>
)
